(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .factory('ColorCode', ColorCode)
      .constant('HIGH',10)
      .constant('LOW',-10)
      .filter('colorConstant', colorConstant);

  // @ngInject
  function colorConstant(HIGH, LOW) {
    return function (threshold) {
      if (threshold) {
        return (threshold == 'HIGH') ? HIGH:LOW;
      }
    };
  }

  // @ngInject
  function ColorCode(HIGH, LOW, translateFilter) {

    var reportKeys = [{key: 'high-color-key', value: translateFilter('reports.returns.key.high')},
      {key: 'medium-color-key', value: translateFilter('reports.returns.key.medium')},
      {key: 'low-color-key', value: translateFilter('reports.returns.key.low')},
      {key: 'one-retailer-color-key', value: translateFilter('reports.returns.key.oneRetailer')}];

    return {
      getKeys : getKeys,
      getColor : getColor
    };

    function getKeys(){
      return reportKeys;
    }

    function getColor(dist) {
      var colorClass = "";
      if(dist == "") {
        colorClass = reportKeys[3].key;
      } else if (dist >= HIGH) {
        colorClass = reportKeys[0].key;
      } else if (HIGH > dist && dist >= LOW) {
        colorClass = reportKeys[1].key;
      } else if (dist < LOW) {
        colorClass = reportKeys[2].key;
      }
      return colorClass;
    }
  }

})();
